import React, { createContext, useContext } from 'react';
import useLocalStorage from 'use-local-storage';

interface LangContextType {
  lang: 'en' | 'zh-CN' | 'zh-HK';
  setLang: (lang: 'en' | 'zh-CN' | 'zh-HK') => void;
  toggleLanguage: () => void;
}

const LangContext = createContext<LangContextType | undefined>(undefined);

export const LangProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const browserLang = navigator.language;
  const [lang, setLang] = useLocalStorage<'en' | 'zh-CN' | 'zh-HK'>('lang', browserLang === 'en' ? 'en' : browserLang === 'zh-HK' ? 'zh-HK' : 'zh-CN');
  const toggleLanguage = () => {
    setLang(lang === 'en' ? 'zh-CN' : lang === 'zh-HK' ? 'zh-CN' : 'en');
  };
  return (
    <LangContext.Provider value={{ lang, setLang, toggleLanguage }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = (): LangContextType => {
  const context = useContext(LangContext);
  if (!context) {
    throw new Error('useLang must be used within a LangProvider');
  }
  return context;
};
